import { jsx as _jsx } from "react/jsx-runtime";
import { useVerticalExternalTimelineProcessController, } from "../../useVerticalTimelineProcessController";
import { TimelineDotDefault, TimelineDotError, TimelineDotSuccess, } from "./TimelineDots";
export function StatusTimelineDotProcess(_a) {
    var data = _a.data, step = _a.step;
    var _b = useVerticalExternalTimelineProcessController({
        data: data,
    }), mustDisplayMessageGotoDetran = _b.mustDisplayMessageGotoDetran, isAttrDateNull = _b.isAttrDateNull, isDateBeforeSecondDate = _b.isDateBeforeSecondDate, findAttributeDateValue = _b.findAttributeDateValue;
    var isProcessDateStep = step.key === "dataProcesso";
    var hasCurrentProcessDate = isDateBeforeSecondDate(data.dataProcesso, findAttributeDateValue(step.key) || undefined);
    if (mustDisplayMessageGotoDetran(step.key)) {
        return _jsx(TimelineDotError, {});
    }
    if (!isProcessDateStep && !hasCurrentProcessDate) {
        return _jsx(TimelineDotDefault, {});
    }
    if (isAttrDateNull(step.key))
        return _jsx(TimelineDotDefault, {});
    return _jsx(TimelineDotSuccess, {});
}
